import { expandAllParentsThenScroll } from '@atlaskit/editor-common/block-menu';

export const scrollToHeader = (
	id: string | undefined,
	shouldExpandParentExpandsOnScroll = false,
): void => {
	if (!id) return;
	const escapedId = id.replace(/[.:;*+?^$!@$^&~%{}()=/|[\]\\]/g, '\\$&');
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const pmodeContent = document.querySelector(`#presenter-mode-container ${escapedId}`);
	if (pmodeContent) {
		pmodeContent.scrollIntoView();
	}

	// Extract the id from the href (remove the # prefix if present)
	const targetId = id.startsWith('#') ? id.substring(1) : id;
	const decodedId = decodeURIComponent(targetId);

	// For normal page view, find the element by id
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const targetElement = document.getElementById(decodedId);
	if (targetElement) {
		if (shouldExpandParentExpandsOnScroll) {
			// Open any collapsed ancestor expand(s) before scrolling to the heading.
			expandAllParentsThenScroll(targetElement);
		}
		// Move focus to the target element for screen reader accessibility
		targetElement.focus();
	}
};
